import style from './style.module.css';
import TextInput from '../Reuseables/Input/TextInput';
import TextArea from '../Reuseables/Input/TextArea';


const Form = ({formData, setFormData, resume, setResume, setErrors, setResumeError, errors, resumeError}) => {
  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };


  // Handle resume upload
  const handleResumeChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setResume(file);
      setResumeError(false);
    }
  };

  

  return (
    <div className="mainWrapper">
      <form className={style.form} >
        <div className={style.wrapper}>
          <p>Name</p>
          <div className={style.name}>
            <TextInput 
              name="firstName"
              placeholder="First Name"
              id="firstName"
              className={style.nameWrap}
              value={formData.firstName}
              onChange={handleChange}
              error={errors.firstName}
            />
            <TextInput 
              name="lastName"
              placeholder="Last Name"
              id="lastName"
              className={style.nameWrap}
              value={formData.lastName}
              onChange={handleChange}
              error={errors.lastName}
            />
          </div>
        </div>

        <TextInput 
          type="email"
          name="email"
          placeholder="@email.com"
          title="Email Address"
          id="email"
          value={formData.email}
          onChange={handleChange}
          error={errors.email}
        />

        <TextInput 
          type="tel"
          name="telephone"
          placeholder="+1234567890"
          title="Phone"
          id="telephone"
          value={formData.telephone}
          onChange={handleChange}
          error={errors.telephone}
        />

        <TextArea 
          id="coverLetter"
          title="Cover Letter"
          name="coverLetter"
          placeholder="Write your cover letter here..."
          value={formData.coverLetter}
          onChange={handleChange}
          error={errors.coverLetter}
        />

        {/* Resume Section */}
        <div className={style.resumeSection}>
          <p>Upload Resume</p>
          <input 
            type="file"
            name="resume"
            accept=".pdf,.docx,.doc"
            onChange={handleResumeChange}
            className={style.fileInput}
          />
          {resume && (
            <div className={style.resumePreview}>
              <p>Selected File: {resume.name}</p>
            </div>
          )}
          {resumeError && (
            <p className={style.error}>Please upload your resume.</p>
          )}
        </div>
      </form>
    </div>
  );
};

export default Form;
